import React from 'react'
import { Helmet } from 'react-helmet'
import GallerySection from '../components/GallerySection'
import Layout from '../components/layouts/Layout'

function Gallary() {
    return (
        <>
            <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai - Gallary</title> </Helmet>
            <Layout>
                <br />
                <br />
                <div className="text-center max-w-3xl mx-auto mb-12">
                    {/* <span className="inline-block px-4 py-2 bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
                        Our Gallary
                    </span> */}
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                        Our{' '}
                        <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
                            Gallary
                        </span>
                    </h2>
                  
                </div>
                <GallerySection/>
            </Layout>
        </>
    )
}

export default Gallary


